import {
    ApiParameter,
    patch,
} from "@insite/client-framework/Services/ApiService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

export interface DeleteShipToApiParameter extends ApiParameter {
    customerId: string;
    shipTo: ShipToModel;
    onSuccess?: () => void;
}

const deleteCustomerUrl = "/api/auersteel/v1/addressbook/deactivateshiptocustomer";

export async function deleteShipToApi(parameter: DeleteShipToApiParameter) {
    const shipTo = await patch<ShipToModel>(
        `${deleteCustomerUrl}?customerId=${parameter.customerId}`,
        parameter.shipTo,
    );
    return shipTo;
}